module.exports = __webpack_public_path__ + "img/alert-read.a483464f.svg";